import { useMemo, useRef, useState } from 'react';
import { plugin, debug } from 'light-component';
import * as Base from '@base';
import { Require } from '../component';
import { useTranslation } from '../../i18n';
import styles from './style.module.less';
import type { WidgetProps } from 'light-component';
import type { Key, ReactElement } from 'react';
import type { GroupOptionItem } from './types';

interface TreeSelectProps extends WidgetProps {
  title: string;
  value?: GroupOptionItem;
  className?: string;
  require?: boolean;
  placeholder?: string;
  options: GroupOptionItem[];
}

export function WidgetQuestionnaireTreeSelect(props: TreeSelectProps): ReactElement {
  debug.widget('dashboard QuestionnaireTreeSelect', props);

  const [selected, setSelected] = useState<string | undefined>(props.value?._id);
  const disabled = useRef<boolean>(true);
  const [t] = useTranslation();

  const onChange = (folderId: string): void => {
    setSelected(folderId);
    props.onChange?.(props.options.find(item => item._id === folderId));
  };

  const treeData = useMemo(() => {
    const folders = props.options.map(item => ({
      id: item._id,
      title: item.name,
      pId: item.parent ?? 'all',
      value: item._id,
      disabled: item.disabled ?? false
    }));

    if (folders.length === 0) {
      return [];
    }

    return folders;
  }, [props.options, t]);

  // 默认展开第一层级的节点
  const expandKeys: Key[] = [];
  const keys = treeData.filter(data => data.pId === '').map(item => item.id);
  expandKeys.push(...keys);
  disabled.current = treeData.length === 0;

  return (
    <div className={props.className}>
      <div className={styles.input}>
        <Require require={props.require} />
        <span className={styles.title}>{t(props.title)}</span>
      </div>
      <Base.TreeSelect
        loading={disabled.current}
        disabled={disabled.current}
        treeDataSimpleMode
        className={styles.treeSelect}
        treeIcon
        value={selected}
        placeholder={props?.placeholder ?? t('请选择文件夹')}
        showSearch
        allowClear
        treeDefaultExpandedKeys={expandKeys}
        autoClearSearchValue
        size='middle'
        treeNodeFilterProp='title'
        treeLine={{ showLeafIcon: false }}
        popupMatchSelectWidth={false}
        treeData={treeData}
        onChange={onChange}
      />
    </div>
  );
}
plugin.register({ kind: 'widget', type: 'questionnaire-tree', component: WidgetQuestionnaireTreeSelect });
